import { isEmpty } from 'ramda';
import { getSimpleSelectValue, getValue } from '../../lib/select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSelectValue } from '../../actions/form';
import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Select as EdocatSelect } from "../../../Select";

interface SelectProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
	helperText: string;
	title: string;
	important: any;
	params: any;
}

class Select extends window.React.PureComponent<SelectProps> {
	updateValue = () => {
		const {
			actions,
			name,
			value,
			control: { template },
			repeating,
			formInstanceId,
			innerFormInstanceId,
		} = this.props;
		if (value && !isEmpty(value) && !template.endsWith('priority.ftl')) {
			actions.getSelectValue(formInstanceId, name, repeating, innerFormInstanceId);
		}
	};

	componentDidMount() {
		this.updateValue();
	}

	componentDidUpdate(prevProps: any) {
		//Transform string value(s) to object(s) on update only if provided value is a string or an array of strings.
		if (
			this.props.value &&
			((Array.isArray(this.props.value) && this.props.value.some(item => !item.hasOwnProperty('value'))) ||
				(!Array.isArray(this.props.value) && !this.props.value.hasOwnProperty('value')))
		) {
			this.updateValue();
		}
	}

	onSelectChange = (value: any) => {
		const { name, onChange } = this.props;
		onChange([name], value, true);
	};

	render() {
		const {
			autoFocus,
			disabled,
			label,
			value,
			options,
			mandatory,
			name,
			className,
			title,
			repeating,
			placeholder,
			error,
			readOnly,
			params,
			helperText,
			important,
		} = this.props;

		return readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div>{getSimpleSelectValue(value, params)}</div>
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<EdocatSelect
					id={name}
					autoFocus={autoFocus}
					className={className}
					disabled={disabled}
					label={label}
					mandatory={mandatory}
					multi={repeating}
					isClearable={!mandatory}
					name={name}
					noResultsText={placeholder || window.Alfresco.messages.global['edocat.text.no-results']}
					onChange={this.onSelectChange}
					options={options}
					placeholder={placeholder}
					searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
					title={title}
					value={getValue(value, options)}
					error={error}
					helperText={helperText}
					important={important}
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ getSelectValue }, dispatch),
});

export default connect(null, mapDispatchToProps)(Select);
